<template>

  <div id="map" />

</template>

<script>
import { createMap, drawPoints } from 'maplibre-gl-js-amplify'
import 'maplibre-gl-js-amplify/dist/public/amplify-map.css'

export default {
  components: {

  },
  props: {
    coordinates: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.initializeMap()
  },
  methods: {
    async initializeMap() {
      const map = await createMap({
        container: 'map', // An HTML Element or HTML element ID to render the map in https://maplibre.org/maplibre-gl-js-docs/api/map/
        center: [this.coordinates[0], this.coordinates[1]], // [Longitude, Latitude]
        markerCoordinates: [this.coordinates[0], this.coordinates[1]],
        zoom: 16,
      })
      map.on('load', () => {
        drawPoints('mySourceName', // Arbitrary source name
          [
            {
              coordinates: [this.coordinates[0], this.coordinates[1]], // [Longitude, Latitude]
              title: 'Golden Gate Bridge',
              address: 'A suspension bridge spanning the Golden Gate',
            },
          ], // An array of coordinate data, an array of Feature data, or an array of [NamedLocations](https://github.com/aws-amplify/maplibre-gl-js-amplify/blob/main/src/types.ts#L8)
          map)
      })
    },
  },
}
</script>

<style>

 #map { position: absolute; top: 0; bottom: 0; width: 100%; height: 100%; }

</style>
